import ajax from "./ajax";

// ── Admin plan management ────────────────────────────────────────────────────

export const getSellerSubscriptionPlans = () =>
  ajax("/seller-subscription-plans");

export const createSellerSubscriptionPlan = (data) =>
  ajax("/seller-subscription-plans", { method: "POST", data });

export const updateSellerSubscriptionPlan = (planId, data) =>
  ajax(`/seller-subscription-plans/${planId}`, { method: "PUT", data });

export const deleteSellerSubscriptionPlan = (planId) =>
  ajax(`/seller-subscription-plans/${planId}`, { method: "DELETE" });

export const seedDefaultPlan = () =>
  ajax("/seller-subscription-plans/seed", { method: "POST" });

// Riverr's 15% of seller-plan money, billed monthly as "Subscription fees"
export const getSubscriptionFeeStatements = () =>
  ajax("/seller-subscription-plans/fee-statements");

export const getSubscriptionFeeStatement = (statementId) =>
  ajax(`/seller-subscription-plans/fee-statements/${statementId}`);

// ── Seller self-serve ────────────────────────────────────────────────────────

export const getMySellerSubscription = () =>
  ajax("/seller-subscription/me");

export const getSellerPlanEntitlements = () =>
  ajax("/seller-subscription/entitlements");

export const switchSellerSubscription = (data) =>
  ajax("/seller-subscription/switch", { method: "POST", data });

// Create Shopify charge — returns { pendingChargeDocId, routeToPython }
// The UI then calls the Python endpoint with pendingChargeDocId.
export const createSellerShopifyCharge = (data) =>
  ajax("/seller-subscription/shopify-charge", { method: "POST", data });

// Verify and activate after Shopify callback
export const confirmSellerShopifyCharge = (data) =>
  ajax("/seller-subscription/shopify-confirm", { method: "POST", data });

export const confirmSellerStripeSubscription = (data) =>
  ajax("/seller-subscription/stripe-confirm", { method: "POST", data });

// Python layer: actually creates the Shopify recurring_application_charge
// Returns { confirmation_url }
export const createSellerShopifyChargePython = (data) =>
  ajax("/shopify/seller-subscription-charge", {
    method: "POST",
    data,
    server: "python",
  });

export const confirmSellerShopifyChargePython = (data) =>
  ajax("/shopify/seller-subscription-confirm", {
    method: "POST",
    data,
    server: "python",
  });

export const cancelSellerSubscription = () =>
  ajax("/seller-subscription/cancel", { method: "POST" });

export const dismissSellerDowngradeNotice = () =>
  ajax("/seller-subscription/dismiss-downgrade-notice", { method: "POST" });
